import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http';
import _ from 'lodash';

const state: ServiceItemState = {
  serviceItems: [],
  serviceItemTotalAvailableQuantity: [],
};

const getters: GetterTree<ServiceItemState, RootState> = {
  // decide if current bookking has enough questack
  assessmentAvailable: (state) => {
    const assessment = state.serviceItems.find(
      (item: Model) => item.key == 'assessment'
    );

    if (!assessment?.object_id) {
      return 0;
    }

    return _.get(
      state.serviceItemTotalAvailableQuantity,
      assessment.object_id,
      0
    );
  },
};

const actions: ActionTree<ServiceItemState, RootState> = {
  fetchList({ commit }, options = {}) {
    return http.v1.si.fetchList(options).then((response) => {
      commit('SET_SERVICE_ITEMS', response.data.data);
      return response;
    });
  },
  serviceItemTotalAvailableQuantity({ commit }, oid) {
    return http.v1.bus
      .serviceItemTotalAvailableQuantity(oid)
      .then((response) => {
        commit(
          'SET_SERVICE_ITEM_TOTAL_AVAILABILITY_QUANTITY',
          response.data.data
        );
        return response;
      });
  },
  discountRuleForBusiness(_, { object_id, payload }) {
    return http.v1.si.discountRuleForBusiness(object_id, payload);
  },
};

const mutations: MutationTree<ServiceItemState> = {
  SET_SERVICE_ITEMS(state, payload) {
    state.serviceItems = payload;
  },
  SET_SERVICE_ITEM_TOTAL_AVAILABILITY_QUANTITY(state, payload) {
    state.serviceItemTotalAvailableQuantity = payload;
  },
};

const serviceItem: Module<ServiceItemState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default serviceItem;
